"use strict";

(function() {

	/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
	/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
	/* Note: if many pages need cleaning up, it can be a solution to put in a script that is loaded in edit mode (eg link target, nbsp, empty tags) */
	if (!(document.querySelector("body").classList.contains("isEditing"))) {

		// Feedback
		if (document.querySelector("main") && !document.querySelector(".frontpage")) {
			loadScript(
				"https://apps.husbanken.no/feedback/feedback.js",
				function() {
					var elm = document.createElement("aside");
					elm.className = "hb-tilbakemelding gtm-feedback";
					elm.setAttribute("aria-label","Tilbakemelding");
					var main = document.querySelector("main");
					main.parentNode.insertBefore(elm, main.nextSibling);
					new FeedbackForm(".hb-tilbakemelding")
				}
			)
		}

	}

})();
